// @flow
import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/main/'
import { ConnectedRouter, routerMiddleware } from 'connected-react-router'
import createSagaMiddleware from 'redux-saga'
import rootSaga from './sagas'
import { Provider } from 'react-redux'
import { applyMiddleware, compose, createStore } from 'redux'
import createRootReducer from 'stores'
import { createMemoryHistory, createBrowserHistory } from 'history'

const createHistory =
  process.env.NODE_ENV === 'production'
    ? createMemoryHistory
    : createBrowserHistory

const history = createHistory({
  basename: process.env.NODE_ENV === 'production' ? '/2018/pop' : ''
})

const sagaMiddleware = createSagaMiddleware()

// compose alternative according to
// https://github.com/zalmoxisus/redux-devtools-extension#12-advanced-store-setup
// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

/**
 * Configure Store
 * @param {Partial<import('./stores').RootState>} [preloadedState]
 * @returns {*}
 */
const configureStore = preloadedState => {
  return createStore(
    createRootReducer(history),
    preloadedState,
    composeEnhancers(applyMiddleware(routerMiddleware(history), sagaMiddleware))
  )
}
const store = configureStore()

// Start root saga
sagaMiddleware.run(rootSaga)

// Render the main component into the dom
const rootElement = document.getElementById('app')

if (rootElement != null) {
  // For the time being we can't take advantage of ReactDOM.hydrate(),
  // as the share buttons use the window.location, which produces wrong
  // attributes in react-snap – which are then not corrected by hydrate()
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>,
    rootElement
  )
}
